import React from 'react'
import { FormattedMessage } from 'react-intl'

const CarbonFootprintImpactUnit = () => {
  return (
    <span className='text-grey-700'>
      <FormattedMessage
        id='ui.CarbonFootprintImpactUnit.unit'
        defaultMessage='kgCO2e'
      />
    </span>
  )
}

const CarbonFootprintImpactValue = ({ value }: { value: number }) => {
  return (
    <div>
      <span className='font-[500]'>{value}</span> <CarbonFootprintImpactUnit />
    </div>
  )
}
export { CarbonFootprintImpactUnit, CarbonFootprintImpactValue }
